module.exports = __webpack_public_path__ + "img/chi.42e710d9.png";